module.exports = __webpack_public_path__ + "img/realme-bk.f4cdaf46.svg";